export type { Spaces } from './spaces'
export { default } from './spaces'
